import Index from './index.vue'

const basePath = '/v-admin/agency/application/profile'

export default {
  path: `${basePath}/:pageType?`,
  component: Index,
  meta: {
    titleI18nKey: 'admin.application.candidate.title.detailResume'
  }
}
